import {
  PropertySchema,
  ResourceSchema,
  RootNodeSchema,
  SchemaExplorer
} from '../types/SchemaExplorer';

export const schemaExplorer: SchemaExplorer = {
  fetching: true,
  failed: false,
  payload: {
    explorerTree: [],
    activeNode: null,
    activeNodeProperties: {
      fetching: true,
      failed: false,
      payload: []
    }
  }
};

export const emptyRootNode: RootNodeSchema = {
  vmid: '',
  name: '',
  description: ''
};

export const emptyChildNode: ResourceSchema = {
  alias: '',
  cardinality: '',
  description: '',
  helpText: '',
  icon: '',
  includedInSearch: false,
  label: '',
  name: '',
  pluralLabel: '',
  resourceType: '',
  selfRelated: false,
  source: '',
  storageType: '',
  template: false,
  vmid: ''
};

export const emptyProperty: PropertySchema = {
  alias: '',
  dataType: '',
  defaultValue: '',
  description: '',
  helpText: '',
  icon: '',
  label: '',
  name: '',
  pluralLabel: '',
  source: '',
  vmid: ''
};
